import { rootInstance } from './axiosConfig';

const expiredListeners = new Set<() => void>();
let refreshPending: Promise<void> | null = null;
let sessionExpired = false;
let generation = 0;

export const onSessionExpired = (callback: () => void) => {
    expiredListeners.add(callback);
    if (sessionExpired) callback();
    return () => { expiredListeners.delete(callback); };
};

// Called after a completed login or a successful authenticated user lookup.
export const markSessionActive = () => {
    generation += 1;
    sessionExpired = false;
};

export const handleSessionExpired = () => {
    if (sessionExpired) return;
    sessionExpired = true;
    expiredListeners.forEach(callback => callback());
    // AuthProvider updates the UI. Never reload login from a failed refresh.
};

export const refreshAccessToken = (): Promise<void> => {
    if (sessionExpired) return Promise.reject(new Error('La sesión finalizó. Inicia sesión nuevamente.'));
    if (!refreshPending) {
        const startedGeneration = generation;
        refreshPending = rootInstance.post('refresh/').then(() => undefined).catch(error => {
            if (error.response?.status === 401 && startedGeneration === generation) handleSessionExpired();
            // A network failure, 403 or 5xx is not proof that the session expired.
            throw error;
        }).finally(() => { refreshPending = null; });
    }
    return refreshPending;
};

export const handleRequestWithAuth = async <T>(requestFunc: () => Promise<T>): Promise<T> => {
    try { return await requestFunc(); }
    catch (error: any) {
        if (error.response?.status !== 401) throw error;
        await refreshAccessToken();
        try { return await requestFunc(); }
        catch (retryError: any) {
            if (retryError.response?.status === 401) handleSessionExpired();
            throw retryError;
        }
    }
};
